module.exports = __webpack_public_path__ + "static/media/_MG_5302.4798f793.jpg";